// language=GraphQL
export const ALL_TRAVELS_QUERY = `query Query($withAvailabilityStatus: Boolean = false, $withAvailabilityStatusTenantSettings: Boolean = false, $withAvailabilityStatusTenantSettingsTenant: Boolean = false, $withTravelConsultant: Boolean = false, $withTravelConsultantImage: Boolean = false, $withLabel: Boolean = false, $withSeoSettings: Boolean = false, $withSeoSettingsOgImage: Boolean = false, $withTenantSettings: Boolean = false, $withTenantSettingsTenant: Boolean = false, $withTenantSettingsTenantCms: Boolean = false, $withTenantSettingsTenantTravelTypes: Boolean = false, $withTenantSettingsTenantEmployees: Boolean = false, $withTenantSettingsTenantEmailConfig: Boolean = false, $withTenantSettingsTenantNewsletterProvider: Boolean = false, $withTenantSettingsTenantRedirects: Boolean = false, $withTenantSettingsTenantOnlinePaymentConfig: Boolean = false, $withTenantSettingsTenantRatioConfig: Boolean = false, $withTenantSettingsTenantContent: Boolean = false, $withTenantSettingsTenantPartnerTenants: Boolean = false, $withTenantSettingsTravelTypes: Boolean = false, $withTenantSettingsTravelTypesImage: Boolean = false, $withHighlights: Boolean = false, $withPartners: Boolean = false, $withPartnersLogo: Boolean = false, $withPartnersGtcPdf: Boolean = false, $withTravelGuides: Boolean = false, $withTravelGuidesImage: Boolean = false, $withTeams: Boolean = false, $withTeamsMembers: Boolean = false, $withTeamsMembersImage: Boolean = false, $withAccommodationAssignments: Boolean = false, $withAccommodationAssignmentsAccommodation: Boolean = false, $withAccommodationAssignmentsAccommodationRoomTypes: Boolean = false, $withAccommodationAssignmentsAccommodationAvailableAddons: Boolean = false, $withAccommodationAssignmentsAccommodationGallery: Boolean = false, $withAccommodationAssignmentsRoomTypes: Boolean = false, $withAccommodationAssignmentsRoomTypesGallery: Boolean = false, $withAccommodations: Boolean = false, $withAccommodationsRoomTypes: Boolean = false, $withAccommodationsRoomTypesGallery: Boolean = false, $withAccommodationsAvailableAddons: Boolean = false, $withAccommodationsAvailableAddonsIcon: Boolean = false, $withAccommodationsGallery: Boolean = false, $withAccommodationsGalleryImages: Boolean = false, $withDestinations: Boolean = false, $withTestimonials: Boolean = false, $withTestimonialsContentBlock: Boolean = false, $withTestimonialsContentBlockImage: Boolean = false, $withMainImage: Boolean = false, $withMainVideo: Boolean = false, $withGallery: Boolean = false, $withGalleryImages: Boolean = false, $withTravelPdf: Boolean = false, $withTravelExtensions: Boolean = false, $withTravelExtensionsHighlights: Boolean = false, $withTravelExtensionsImage: Boolean = false, $withItinerary: Boolean = false, $withItineraryItems: Boolean = false, $withItineraryItemsImage: Boolean = false, $withItineraryItemsMapMarkers: Boolean = false, $withPricing: Boolean = false, $withPricingAgeGroupSettings: Boolean = false, $withPricingAgeGroupSettingsAgeGroups: Boolean = false, $withPricingCustomDataConfig: Boolean = false, $withPricingCustomDataConfigTravellerForm: Boolean = false, $withPricingCustomDataConfigBookingForm: Boolean = false, $withPricingTravels: Boolean = false, $withPricingTravelsRatioCatalogBundle: Boolean = false, $withPricingTravelsDates: Boolean = false, $withPricingTravelsAccommodations: Boolean = false, $withPricingTravelsExtensionAccommodations: Boolean = false, $withPricingTravelsFamilyPackages: Boolean = false, $withPricingTravelsPersonalAddons: Boolean = false, $withPricingTravelsAccommodationAddons: Boolean = false, $withPricingTravelsBookingAddons: Boolean = false, $withPricingTravelsCollectiveAddons: Boolean = false, $withPricingTravelsExtensions: Boolean = false, $withPricingTravelsPersonalDiscounts: Boolean = false, $withPricingTravelsBookingDiscounts: Boolean = false, $withPricingTravelsCollectiveDiscounts: Boolean = false, $withPricingWebhookConfig: Boolean = false, $withPricingBranding: Boolean = false, $withPricingBrandingLogo: Boolean = false, $withPricingBargainSettings: Boolean = false, $withPricingBargainSettingsBargainTier: Boolean = false, $withPricingEsimSettings: Boolean = false, $withPricingEsimSettingsRegions: Boolean = false, $withPricingPassportConfig: Boolean = false, $withPricingTourOperator: Boolean = false, $withPricingTourOperatorLogo: Boolean = false, $withPricingTourOperatorGtcPdf: Boolean = false, $withPricingCurrencyOverride: Boolean = false, $withPricingCurrencyOverrideCurrency: Boolean = false, $withFaqs: Boolean = false) {
  travels: travels {
    id
    name
    isBestseller
    startDate
    endDate
    availabilityStatus @include(if: $withAvailabilityStatus) {
      id
      label
      status
      isDefaultStatus
      isDefaultWaitlistFallback
      tenantSettings @include(if: $withAvailabilityStatusTenantSettings) {
        id
        tenant @include(if: $withAvailabilityStatusTenantSettingsTenant) {
          id
          name
          slug
          domain
          externalReference
        }
        label
        info
        switchToStatusInfo
        submitButtonLabel
      }
    }
    executionStatus
    travelConsultant @include(if: $withTravelConsultant) {
      id
      firstName
      lastName
      jobTitle
      description
      email
      image @include(if: $withTravelConsultantImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      phone
    }
    label @include(if: $withLabel) {
      id
      label
    }
    title
    description
    introVideoUrl
    includedServices
    excludedServices
    pricingTable
    priceCalculationInfo
    seoSettings @include(if: $withSeoSettings) {
      id
      urlSlug
      metaTitle
      metaDescription
      ogTitle
      ogDescription
      ogImage @include(if: $withSeoSettingsOgImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
    tenantSettings @include(if: $withTenantSettings) {
      id
      tenant @include(if: $withTenantSettingsTenant) {
        id
        name
        slug
        domain
        externalReference
        cms @include(if: $withTenantSettingsTenantCms) {
          id
        }
        travelTypes @include(if: $withTenantSettingsTenantTravelTypes) {
          id
          name
          description
        }
        employees @include(if: $withTenantSettingsTenantEmployees) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          phone
        }
        emailConfig @include(if: $withTenantSettingsTenantEmailConfig) {
          id
          defaultInternalRecipientEmail
          internalBookingRecipientEmails
          bookingConfirmationTemplateId
          bookingConfirmationInternalTemplateId
          bookingRequestConfirmationTemplateId
          bookingWaitlistConfirmationTemplateId
          bookingWaitlistContingentCheckConfirmationTemplateId
          bookingCustomRequestTemplateId
          bookingPassportDataReminderTemplateId
          previewTravelInterestTemplateId
          contactFormTemplateId
          esimInstallationInfoTemplateId
        }
        newsletterProvider @include(if: $withTenantSettingsTenantNewsletterProvider) {
          id
          provider
        }
        redirects @include(if: $withTenantSettingsTenantRedirects) {
          id
          fromType
          fromUrl
          toType
          toUrl
        }
        onlinePaymentConfig @include(if: $withTenantSettingsTenantOnlinePaymentConfig) {
          id
          enabled
          datatransMerchantId
          datatransMerchantPw
          ratioFibuAccountNo
          infoText
          datatransThemeConfig
        }
        ratioConfig @include(if: $withTenantSettingsTenantRatioConfig) {
          id
          adressgruppe
        }
        content @include(if: $withTenantSettingsTenantContent) {
          id
          bookingInsuranceInfo
          co2CompensationInfo
        }
        partnerTenants @include(if: $withTenantSettingsTenantPartnerTenants) {
          id
          filterCrossLinking
        }
      }
      onlineStatus
      redirectToBooking
      useTiming
      startDate
      endDate
      travelTypes @include(if: $withTenantSettingsTravelTypes) {
        id
        name
        description
        image @include(if: $withTenantSettingsTravelTypesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
    }
    highlights @include(if: $withHighlights) {
      id
      text
    }
    partners @include(if: $withPartners) {
      id
      name
      url
      logo @include(if: $withPartnersLogo) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      logoWidth
      gtcPdf @include(if: $withPartnersGtcPdf) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
    travelGuides @include(if: $withTravelGuides) {
      id
      firstName
      lastName
      description
      image @include(if: $withTravelGuidesImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
    teams @include(if: $withTeams) {
      id
      name
      members @include(if: $withTeamsMembers) {
        id
        firstName
        lastName
        description
        image @include(if: $withTeamsMembersImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
    }
    accommodationAssignments @include(if: $withAccommodationAssignments) {
      id
      accommodation @include(if: $withAccommodationAssignmentsAccommodation) {
        id
        label
        name
        stars
        description
        roomTypes @include(if: $withAccommodationAssignmentsAccommodationRoomTypes) {
          id
          name
          description
        }
        availableAddons @include(if: $withAccommodationAssignmentsAccommodationAvailableAddons) {
          id
          name
          description
        }
        gallery @include(if: $withAccommodationAssignmentsAccommodationGallery) {
          id
        }
      }
      roomTypes @include(if: $withAccommodationAssignmentsRoomTypes) {
        id
        name
        description
        gallery @include(if: $withAccommodationAssignmentsRoomTypesGallery) {
          id
        }
      }
      useCustomRoomTypeSelection
      displayDetails
    }
    accommodations @include(if: $withAccommodations) {
      id
      label
      name
      stars
      description
      roomTypes @include(if: $withAccommodationsRoomTypes) {
        id
        name
        description
        gallery @include(if: $withAccommodationsRoomTypesGallery) {
          id
        }
      }
      availableAddons @include(if: $withAccommodationsAvailableAddons) {
        id
        name
        description
        icon @include(if: $withAccommodationsAvailableAddonsIcon) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      gallery @include(if: $withAccommodationsGallery) {
        id
        images @include(if: $withAccommodationsGalleryImages) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
    }
    destinations @include(if: $withDestinations) {
      id
      name
      entryRequirements
      medicalInformation
      language
      timeShift
      climate
      currency
    }
    testimonials @include(if: $withTestimonials) {
      id
      contentBlock @include(if: $withTestimonialsContentBlock) {
        id
        title
        text
        image @include(if: $withTestimonialsContentBlockImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        imagePosition
      }
    }
    mainImage @include(if: $withMainImage) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
    mainVideo @include(if: $withMainVideo) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
    gallery @include(if: $withGallery) {
      id
      images @include(if: $withGalleryImages) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
    travelPdf @include(if: $withTravelPdf) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
    travelExtensions @include(if: $withTravelExtensions) {
      id
      duration
      name
      description
      highlights @include(if: $withTravelExtensionsHighlights) {
        id
        text
      }
      image @include(if: $withTravelExtensionsImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
    programType
    itinerary @include(if: $withItinerary) {
      id
      items @include(if: $withItineraryItems) {
        id
        duration
        title
        text
        image @include(if: $withItineraryItemsImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        mapMarkers @include(if: $withItineraryItemsMapMarkers) {
          id
          lat
          lng
        }
      }
    }
    programText
    pricing @include(if: $withPricing) {
      id
      ageGroupSettings @include(if: $withPricingAgeGroupSettings) {
        id
        freeUntilAge
        ageGroups @include(if: $withPricingAgeGroupSettingsAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
      }
      isTravelDocumentationAvailable
      customDataConfig @include(if: $withPricingCustomDataConfig) {
        id
        useTravellerForm
        travellerForm @include(if: $withPricingCustomDataConfigTravellerForm) {
          id
        }
        useBookingForm
        bookingForm @include(if: $withPricingCustomDataConfigBookingForm) {
          id
        }
      }
      travels @include(if: $withPricingTravels) {
        id
        ratioCatalogBundle @include(if: $withPricingTravelsRatioCatalogBundle) {
          id
          catalogCode
          travelCode
          json
        }
        catalogCode
        travelCode
        destination
        name
        transportType
        transportTypeLabel
        dates @include(if: $withPricingTravelsDates) {
          id
          dateNo
          startDate
          endDate
          isHidden
          includesExtension
          json
        }
        accommodations @include(if: $withPricingTravelsAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        extensionAccommodations @include(if: $withPricingTravelsExtensionAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          extensionAccommodationServiceNo
        }
        familyPackages @include(if: $withPricingTravelsFamilyPackages) {
          id
          ratioServiceNo
          name
          label
          info
        }
        personalAddons @include(if: $withPricingTravelsPersonalAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
        accommodationAddons @include(if: $withPricingTravelsAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
        bookingAddons @include(if: $withPricingTravelsBookingAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
        collectiveAddons @include(if: $withPricingTravelsCollectiveAddons) {
          id
          label
          info
        }
        extensions @include(if: $withPricingTravelsExtensions) {
          id
          label
          info
        }
        personalDiscounts @include(if: $withPricingTravelsPersonalDiscounts) {
          id
          ratioServiceNo
          name
          label
          info
        }
        bookingDiscounts @include(if: $withPricingTravelsBookingDiscounts) {
          id
          ratioServiceNo
          name
          label
          info
        }
        collectiveDiscounts @include(if: $withPricingTravelsCollectiveDiscounts) {
          id
          label
          info
        }
        importDateTime
        importStatus
        suppressBusBoardingSelection
      }
      webhookConfig @include(if: $withPricingWebhookConfig) {
        id
        enabled
        url
      }
      branding @include(if: $withPricingBranding) {
        id
        logo @include(if: $withPricingBrandingLogo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        logoWidth
      }
      bargainSettings @include(if: $withPricingBargainSettings) {
        id
        active
        untilDaysBeforeStart
        bargainTier @include(if: $withPricingBargainSettingsBargainTier) {
          id
          fromPrice
          discount
        }
      }
      esimSettings @include(if: $withPricingEsimSettings) {
        id
        enabled
        regions @include(if: $withPricingEsimSettingsRegions) {
          id
          name
          serviceCodePrefix
        }
      }
      passportConfig @include(if: $withPricingPassportConfig) {
        id
        passportOnly
      }
      tourOperator @include(if: $withPricingTourOperator) {
        id
        name
        url
        logo @include(if: $withPricingTourOperatorLogo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        logoWidth
        gtcPdf @include(if: $withPricingTourOperatorGtcPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      currencyOverride @include(if: $withPricingCurrencyOverride) {
        id
        enabled
        currency @include(if: $withPricingCurrencyOverrideCurrency) {
          id
          name
          symbol
          code
          isDefault
          exchangeRate
          defaultCountries
        }
        exchangeRate
      }
    }
    minPrice
    minPriceManualOverride
    currency
    faqs @include(if: $withFaqs) {
      id
      question
      answer
    }
  }
}`

// language=GraphQL
export const SINGLE_TRAVEL_QUERY = `query Query($id: ID!, $withAvailabilityStatus: Boolean = false, $withAvailabilityStatusTenantSettings: Boolean = false, $withAvailabilityStatusTenantSettingsTenant: Boolean = false, $withTravelConsultant: Boolean = false, $withTravelConsultantImage: Boolean = false, $withLabel: Boolean = false, $withSeoSettings: Boolean = false, $withSeoSettingsOgImage: Boolean = false, $withTenantSettings: Boolean = false, $withTenantSettingsTenant: Boolean = false, $withTenantSettingsTenantCms: Boolean = false, $withTenantSettingsTenantTravelTypes: Boolean = false, $withTenantSettingsTenantEmployees: Boolean = false, $withTenantSettingsTenantEmailConfig: Boolean = false, $withTenantSettingsTenantNewsletterProvider: Boolean = false, $withTenantSettingsTenantRedirects: Boolean = false, $withTenantSettingsTenantOnlinePaymentConfig: Boolean = false, $withTenantSettingsTenantRatioConfig: Boolean = false, $withTenantSettingsTenantContent: Boolean = false, $withTenantSettingsTenantPartnerTenants: Boolean = false, $withTenantSettingsTravelTypes: Boolean = false, $withTenantSettingsTravelTypesImage: Boolean = false, $withHighlights: Boolean = false, $withPartners: Boolean = false, $withPartnersLogo: Boolean = false, $withPartnersGtcPdf: Boolean = false, $withTravelGuides: Boolean = false, $withTravelGuidesImage: Boolean = false, $withTeams: Boolean = false, $withTeamsMembers: Boolean = false, $withTeamsMembersImage: Boolean = false, $withAccommodationAssignments: Boolean = false, $withAccommodationAssignmentsAccommodation: Boolean = false, $withAccommodationAssignmentsAccommodationRoomTypes: Boolean = false, $withAccommodationAssignmentsAccommodationAvailableAddons: Boolean = false, $withAccommodationAssignmentsAccommodationGallery: Boolean = false, $withAccommodationAssignmentsRoomTypes: Boolean = false, $withAccommodationAssignmentsRoomTypesGallery: Boolean = false, $withAccommodations: Boolean = false, $withAccommodationsRoomTypes: Boolean = false, $withAccommodationsRoomTypesGallery: Boolean = false, $withAccommodationsAvailableAddons: Boolean = false, $withAccommodationsAvailableAddonsIcon: Boolean = false, $withAccommodationsGallery: Boolean = false, $withAccommodationsGalleryImages: Boolean = false, $withDestinations: Boolean = false, $withTestimonials: Boolean = false, $withTestimonialsContentBlock: Boolean = false, $withTestimonialsContentBlockImage: Boolean = false, $withMainImage: Boolean = false, $withMainVideo: Boolean = false, $withGallery: Boolean = false, $withGalleryImages: Boolean = false, $withTravelPdf: Boolean = false, $withTravelExtensions: Boolean = false, $withTravelExtensionsHighlights: Boolean = false, $withTravelExtensionsImage: Boolean = false, $withItinerary: Boolean = false, $withItineraryItems: Boolean = false, $withItineraryItemsImage: Boolean = false, $withItineraryItemsMapMarkers: Boolean = false, $withPricing: Boolean = false, $withPricingAgeGroupSettings: Boolean = false, $withPricingAgeGroupSettingsAgeGroups: Boolean = false, $withPricingCustomDataConfig: Boolean = false, $withPricingCustomDataConfigTravellerForm: Boolean = false, $withPricingCustomDataConfigBookingForm: Boolean = false, $withPricingTravels: Boolean = false, $withPricingTravelsRatioCatalogBundle: Boolean = false, $withPricingTravelsDates: Boolean = false, $withPricingTravelsAccommodations: Boolean = false, $withPricingTravelsExtensionAccommodations: Boolean = false, $withPricingTravelsFamilyPackages: Boolean = false, $withPricingTravelsPersonalAddons: Boolean = false, $withPricingTravelsAccommodationAddons: Boolean = false, $withPricingTravelsBookingAddons: Boolean = false, $withPricingTravelsCollectiveAddons: Boolean = false, $withPricingTravelsExtensions: Boolean = false, $withPricingTravelsPersonalDiscounts: Boolean = false, $withPricingTravelsBookingDiscounts: Boolean = false, $withPricingTravelsCollectiveDiscounts: Boolean = false, $withPricingWebhookConfig: Boolean = false, $withPricingBranding: Boolean = false, $withPricingBrandingLogo: Boolean = false, $withPricingBargainSettings: Boolean = false, $withPricingBargainSettingsBargainTier: Boolean = false, $withPricingEsimSettings: Boolean = false, $withPricingEsimSettingsRegions: Boolean = false, $withPricingPassportConfig: Boolean = false, $withPricingTourOperator: Boolean = false, $withPricingTourOperatorLogo: Boolean = false, $withPricingTourOperatorGtcPdf: Boolean = false, $withPricingCurrencyOverride: Boolean = false, $withPricingCurrencyOverrideCurrency: Boolean = false, $withFaqs: Boolean = false) {
  travel: travel(id: $id) {
    id
    name
    isBestseller
    startDate
    endDate
    availabilityStatus @include(if: $withAvailabilityStatus) {
      id
      label
      status
      isDefaultStatus
      isDefaultWaitlistFallback
      tenantSettings @include(if: $withAvailabilityStatusTenantSettings) {
        id
        tenant @include(if: $withAvailabilityStatusTenantSettingsTenant) {
          id
          name
          slug
          domain
          externalReference
        }
        label
        info
        switchToStatusInfo
        submitButtonLabel
      }
    }
    executionStatus
    travelConsultant @include(if: $withTravelConsultant) {
      id
      firstName
      lastName
      jobTitle
      description
      email
      image @include(if: $withTravelConsultantImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      phone
    }
    label @include(if: $withLabel) {
      id
      label
    }
    title
    description
    introVideoUrl
    includedServices
    excludedServices
    pricingTable
    priceCalculationInfo
    seoSettings @include(if: $withSeoSettings) {
      id
      urlSlug
      metaTitle
      metaDescription
      ogTitle
      ogDescription
      ogImage @include(if: $withSeoSettingsOgImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
    tenantSettings @include(if: $withTenantSettings) {
      id
      tenant @include(if: $withTenantSettingsTenant) {
        id
        name
        slug
        domain
        externalReference
        cms @include(if: $withTenantSettingsTenantCms) {
          id
        }
        travelTypes @include(if: $withTenantSettingsTenantTravelTypes) {
          id
          name
          description
        }
        employees @include(if: $withTenantSettingsTenantEmployees) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          phone
        }
        emailConfig @include(if: $withTenantSettingsTenantEmailConfig) {
          id
          defaultInternalRecipientEmail
          internalBookingRecipientEmails
          bookingConfirmationTemplateId
          bookingConfirmationInternalTemplateId
          bookingRequestConfirmationTemplateId
          bookingWaitlistConfirmationTemplateId
          bookingWaitlistContingentCheckConfirmationTemplateId
          bookingCustomRequestTemplateId
          bookingPassportDataReminderTemplateId
          previewTravelInterestTemplateId
          contactFormTemplateId
          esimInstallationInfoTemplateId
        }
        newsletterProvider @include(if: $withTenantSettingsTenantNewsletterProvider) {
          id
          provider
        }
        redirects @include(if: $withTenantSettingsTenantRedirects) {
          id
          fromType
          fromUrl
          toType
          toUrl
        }
        onlinePaymentConfig @include(if: $withTenantSettingsTenantOnlinePaymentConfig) {
          id
          enabled
          datatransMerchantId
          datatransMerchantPw
          ratioFibuAccountNo
          infoText
          datatransThemeConfig
        }
        ratioConfig @include(if: $withTenantSettingsTenantRatioConfig) {
          id
          adressgruppe
        }
        content @include(if: $withTenantSettingsTenantContent) {
          id
          bookingInsuranceInfo
          co2CompensationInfo
        }
        partnerTenants @include(if: $withTenantSettingsTenantPartnerTenants) {
          id
          filterCrossLinking
        }
      }
      onlineStatus
      redirectToBooking
      useTiming
      startDate
      endDate
      travelTypes @include(if: $withTenantSettingsTravelTypes) {
        id
        name
        description
        image @include(if: $withTenantSettingsTravelTypesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
    }
    highlights @include(if: $withHighlights) {
      id
      text
    }
    partners @include(if: $withPartners) {
      id
      name
      url
      logo @include(if: $withPartnersLogo) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      logoWidth
      gtcPdf @include(if: $withPartnersGtcPdf) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
    travelGuides @include(if: $withTravelGuides) {
      id
      firstName
      lastName
      description
      image @include(if: $withTravelGuidesImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
    teams @include(if: $withTeams) {
      id
      name
      members @include(if: $withTeamsMembers) {
        id
        firstName
        lastName
        description
        image @include(if: $withTeamsMembersImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
    }
    accommodationAssignments @include(if: $withAccommodationAssignments) {
      id
      accommodation @include(if: $withAccommodationAssignmentsAccommodation) {
        id
        label
        name
        stars
        description
        roomTypes @include(if: $withAccommodationAssignmentsAccommodationRoomTypes) {
          id
          name
          description
        }
        availableAddons @include(if: $withAccommodationAssignmentsAccommodationAvailableAddons) {
          id
          name
          description
        }
        gallery @include(if: $withAccommodationAssignmentsAccommodationGallery) {
          id
        }
      }
      roomTypes @include(if: $withAccommodationAssignmentsRoomTypes) {
        id
        name
        description
        gallery @include(if: $withAccommodationAssignmentsRoomTypesGallery) {
          id
        }
      }
      useCustomRoomTypeSelection
      displayDetails
    }
    accommodations @include(if: $withAccommodations) {
      id
      label
      name
      stars
      description
      roomTypes @include(if: $withAccommodationsRoomTypes) {
        id
        name
        description
        gallery @include(if: $withAccommodationsRoomTypesGallery) {
          id
        }
      }
      availableAddons @include(if: $withAccommodationsAvailableAddons) {
        id
        name
        description
        icon @include(if: $withAccommodationsAvailableAddonsIcon) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      gallery @include(if: $withAccommodationsGallery) {
        id
        images @include(if: $withAccommodationsGalleryImages) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
    }
    destinations @include(if: $withDestinations) {
      id
      name
      entryRequirements
      medicalInformation
      language
      timeShift
      climate
      currency
    }
    testimonials @include(if: $withTestimonials) {
      id
      contentBlock @include(if: $withTestimonialsContentBlock) {
        id
        title
        text
        image @include(if: $withTestimonialsContentBlockImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        imagePosition
      }
    }
    mainImage @include(if: $withMainImage) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
    mainVideo @include(if: $withMainVideo) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
    gallery @include(if: $withGallery) {
      id
      images @include(if: $withGalleryImages) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
    travelPdf @include(if: $withTravelPdf) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
    travelExtensions @include(if: $withTravelExtensions) {
      id
      duration
      name
      description
      highlights @include(if: $withTravelExtensionsHighlights) {
        id
        text
      }
      image @include(if: $withTravelExtensionsImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
    programType
    itinerary @include(if: $withItinerary) {
      id
      items @include(if: $withItineraryItems) {
        id
        duration
        title
        text
        image @include(if: $withItineraryItemsImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        mapMarkers @include(if: $withItineraryItemsMapMarkers) {
          id
          lat
          lng
        }
      }
    }
    programText
    pricing @include(if: $withPricing) {
      id
      ageGroupSettings @include(if: $withPricingAgeGroupSettings) {
        id
        freeUntilAge
        ageGroups @include(if: $withPricingAgeGroupSettingsAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
      }
      isTravelDocumentationAvailable
      customDataConfig @include(if: $withPricingCustomDataConfig) {
        id
        useTravellerForm
        travellerForm @include(if: $withPricingCustomDataConfigTravellerForm) {
          id
        }
        useBookingForm
        bookingForm @include(if: $withPricingCustomDataConfigBookingForm) {
          id
        }
      }
      travels @include(if: $withPricingTravels) {
        id
        ratioCatalogBundle @include(if: $withPricingTravelsRatioCatalogBundle) {
          id
          catalogCode
          travelCode
          json
        }
        catalogCode
        travelCode
        destination
        name
        transportType
        transportTypeLabel
        dates @include(if: $withPricingTravelsDates) {
          id
          dateNo
          startDate
          endDate
          isHidden
          includesExtension
          json
        }
        accommodations @include(if: $withPricingTravelsAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        extensionAccommodations @include(if: $withPricingTravelsExtensionAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          extensionAccommodationServiceNo
        }
        familyPackages @include(if: $withPricingTravelsFamilyPackages) {
          id
          ratioServiceNo
          name
          label
          info
        }
        personalAddons @include(if: $withPricingTravelsPersonalAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
        accommodationAddons @include(if: $withPricingTravelsAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
        bookingAddons @include(if: $withPricingTravelsBookingAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
        collectiveAddons @include(if: $withPricingTravelsCollectiveAddons) {
          id
          label
          info
        }
        extensions @include(if: $withPricingTravelsExtensions) {
          id
          label
          info
        }
        personalDiscounts @include(if: $withPricingTravelsPersonalDiscounts) {
          id
          ratioServiceNo
          name
          label
          info
        }
        bookingDiscounts @include(if: $withPricingTravelsBookingDiscounts) {
          id
          ratioServiceNo
          name
          label
          info
        }
        collectiveDiscounts @include(if: $withPricingTravelsCollectiveDiscounts) {
          id
          label
          info
        }
        importDateTime
        importStatus
        suppressBusBoardingSelection
      }
      webhookConfig @include(if: $withPricingWebhookConfig) {
        id
        enabled
        url
      }
      branding @include(if: $withPricingBranding) {
        id
        logo @include(if: $withPricingBrandingLogo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        logoWidth
      }
      bargainSettings @include(if: $withPricingBargainSettings) {
        id
        active
        untilDaysBeforeStart
        bargainTier @include(if: $withPricingBargainSettingsBargainTier) {
          id
          fromPrice
          discount
        }
      }
      esimSettings @include(if: $withPricingEsimSettings) {
        id
        enabled
        regions @include(if: $withPricingEsimSettingsRegions) {
          id
          name
          serviceCodePrefix
        }
      }
      passportConfig @include(if: $withPricingPassportConfig) {
        id
        passportOnly
      }
      tourOperator @include(if: $withPricingTourOperator) {
        id
        name
        url
        logo @include(if: $withPricingTourOperatorLogo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        logoWidth
        gtcPdf @include(if: $withPricingTourOperatorGtcPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      currencyOverride @include(if: $withPricingCurrencyOverride) {
        id
        enabled
        currency @include(if: $withPricingCurrencyOverrideCurrency) {
          id
          name
          symbol
          code
          isDefault
          exchangeRate
          defaultCountries
        }
        exchangeRate
      }
    }
    minPrice
    minPriceManualOverride
    currency
    faqs @include(if: $withFaqs) {
      id
      question
      answer
    }
  }
}`

// language=GraphQL
export const CREATE_TRAVEL_MUTATION = `
  mutation Mutation($input: CreateTravelInput, $withAvailabilityStatus: Boolean = false, $withAvailabilityStatusTenantSettings: Boolean = false, $withAvailabilityStatusTenantSettingsTenant: Boolean = false, $withTravelConsultant: Boolean = false, $withTravelConsultantImage: Boolean = false, $withLabel: Boolean = false, $withSeoSettings: Boolean = false, $withSeoSettingsOgImage: Boolean = false, $withTenantSettings: Boolean = false, $withTenantSettingsTenant: Boolean = false, $withTenantSettingsTenantCms: Boolean = false, $withTenantSettingsTenantTravelTypes: Boolean = false, $withTenantSettingsTenantEmployees: Boolean = false, $withTenantSettingsTenantEmailConfig: Boolean = false, $withTenantSettingsTenantNewsletterProvider: Boolean = false, $withTenantSettingsTenantRedirects: Boolean = false, $withTenantSettingsTenantOnlinePaymentConfig: Boolean = false, $withTenantSettingsTenantRatioConfig: Boolean = false, $withTenantSettingsTenantContent: Boolean = false, $withTenantSettingsTenantPartnerTenants: Boolean = false, $withTenantSettingsTravelTypes: Boolean = false, $withTenantSettingsTravelTypesImage: Boolean = false, $withHighlights: Boolean = false, $withPartners: Boolean = false, $withPartnersLogo: Boolean = false, $withPartnersGtcPdf: Boolean = false, $withTravelGuides: Boolean = false, $withTravelGuidesImage: Boolean = false, $withTeams: Boolean = false, $withTeamsMembers: Boolean = false, $withTeamsMembersImage: Boolean = false, $withAccommodationAssignments: Boolean = false, $withAccommodationAssignmentsAccommodation: Boolean = false, $withAccommodationAssignmentsAccommodationRoomTypes: Boolean = false, $withAccommodationAssignmentsAccommodationAvailableAddons: Boolean = false, $withAccommodationAssignmentsAccommodationGallery: Boolean = false, $withAccommodationAssignmentsRoomTypes: Boolean = false, $withAccommodationAssignmentsRoomTypesGallery: Boolean = false, $withAccommodations: Boolean = false, $withAccommodationsRoomTypes: Boolean = false, $withAccommodationsRoomTypesGallery: Boolean = false, $withAccommodationsAvailableAddons: Boolean = false, $withAccommodationsAvailableAddonsIcon: Boolean = false, $withAccommodationsGallery: Boolean = false, $withAccommodationsGalleryImages: Boolean = false, $withDestinations: Boolean = false, $withTestimonials: Boolean = false, $withTestimonialsContentBlock: Boolean = false, $withTestimonialsContentBlockImage: Boolean = false, $withMainImage: Boolean = false, $withMainVideo: Boolean = false, $withGallery: Boolean = false, $withGalleryImages: Boolean = false, $withTravelPdf: Boolean = false, $withTravelExtensions: Boolean = false, $withTravelExtensionsHighlights: Boolean = false, $withTravelExtensionsImage: Boolean = false, $withItinerary: Boolean = false, $withItineraryItems: Boolean = false, $withItineraryItemsImage: Boolean = false, $withItineraryItemsMapMarkers: Boolean = false, $withPricing: Boolean = false, $withPricingAgeGroupSettings: Boolean = false, $withPricingAgeGroupSettingsAgeGroups: Boolean = false, $withPricingCustomDataConfig: Boolean = false, $withPricingCustomDataConfigTravellerForm: Boolean = false, $withPricingCustomDataConfigBookingForm: Boolean = false, $withPricingTravels: Boolean = false, $withPricingTravelsRatioCatalogBundle: Boolean = false, $withPricingTravelsDates: Boolean = false, $withPricingTravelsAccommodations: Boolean = false, $withPricingTravelsExtensionAccommodations: Boolean = false, $withPricingTravelsFamilyPackages: Boolean = false, $withPricingTravelsPersonalAddons: Boolean = false, $withPricingTravelsAccommodationAddons: Boolean = false, $withPricingTravelsBookingAddons: Boolean = false, $withPricingTravelsCollectiveAddons: Boolean = false, $withPricingTravelsExtensions: Boolean = false, $withPricingTravelsPersonalDiscounts: Boolean = false, $withPricingTravelsBookingDiscounts: Boolean = false, $withPricingTravelsCollectiveDiscounts: Boolean = false, $withPricingWebhookConfig: Boolean = false, $withPricingBranding: Boolean = false, $withPricingBrandingLogo: Boolean = false, $withPricingBargainSettings: Boolean = false, $withPricingBargainSettingsBargainTier: Boolean = false, $withPricingEsimSettings: Boolean = false, $withPricingEsimSettingsRegions: Boolean = false, $withPricingPassportConfig: Boolean = false, $withPricingTourOperator: Boolean = false, $withPricingTourOperatorLogo: Boolean = false, $withPricingTourOperatorGtcPdf: Boolean = false, $withPricingCurrencyOverride: Boolean = false, $withPricingCurrencyOverrideCurrency: Boolean = false, $withFaqs: Boolean = false) {
    travel: createTravel(input: $input) {
      id
      name
      isBestseller
      startDate
      endDate
      availabilityStatus @include(if: $withAvailabilityStatus) {
        id
        label
        status
        isDefaultStatus
        isDefaultWaitlistFallback
        tenantSettings @include(if: $withAvailabilityStatusTenantSettings) {
          id
          tenant @include(if: $withAvailabilityStatusTenantSettingsTenant) {
            id
            name
            slug
            domain
            externalReference
          }
          label
          info
          switchToStatusInfo
          submitButtonLabel
        }
      }
      executionStatus
      travelConsultant @include(if: $withTravelConsultant) {
        id
        firstName
        lastName
        jobTitle
        description
        email
        image @include(if: $withTravelConsultantImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        phone
      }
      label @include(if: $withLabel) {
        id
        label
      }
      title
      description
      introVideoUrl
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      seoSettings @include(if: $withSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      tenantSettings @include(if: $withTenantSettings) {
        id
        tenant @include(if: $withTenantSettingsTenant) {
          id
          name
          slug
          domain
          externalReference
          cms @include(if: $withTenantSettingsTenantCms) {
            id
          }
          travelTypes @include(if: $withTenantSettingsTenantTravelTypes) {
            id
            name
            description
          }
          employees @include(if: $withTenantSettingsTenantEmployees) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }
          emailConfig @include(if: $withTenantSettingsTenantEmailConfig) {
            id
            defaultInternalRecipientEmail
            internalBookingRecipientEmails
            bookingConfirmationTemplateId
            bookingConfirmationInternalTemplateId
            bookingRequestConfirmationTemplateId
            bookingWaitlistConfirmationTemplateId
            bookingWaitlistContingentCheckConfirmationTemplateId
            bookingCustomRequestTemplateId
            bookingPassportDataReminderTemplateId
            previewTravelInterestTemplateId
            contactFormTemplateId
            esimInstallationInfoTemplateId
          }
          newsletterProvider @include(if: $withTenantSettingsTenantNewsletterProvider) {
            id
            provider
          }
          redirects @include(if: $withTenantSettingsTenantRedirects) {
            id
            fromType
            fromUrl
            toType
            toUrl
          }
          onlinePaymentConfig @include(if: $withTenantSettingsTenantOnlinePaymentConfig) {
            id
            enabled
            datatransMerchantId
            datatransMerchantPw
            ratioFibuAccountNo
            infoText
            datatransThemeConfig
          }
          ratioConfig @include(if: $withTenantSettingsTenantRatioConfig) {
            id
            adressgruppe
          }
          content @include(if: $withTenantSettingsTenantContent) {
            id
            bookingInsuranceInfo
            co2CompensationInfo
          }
          partnerTenants @include(if: $withTenantSettingsTenantPartnerTenants) {
            id
            filterCrossLinking
          }
        }
        onlineStatus
        redirectToBooking
        useTiming
        startDate
        endDate
        travelTypes @include(if: $withTenantSettingsTravelTypes) {
          id
          name
          description
          image @include(if: $withTenantSettingsTravelTypesImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
      }
      highlights @include(if: $withHighlights) {
        id
        text
      }
      partners @include(if: $withPartners) {
        id
        name
        url
        logo @include(if: $withPartnersLogo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        logoWidth
        gtcPdf @include(if: $withPartnersGtcPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      travelGuides @include(if: $withTravelGuides) {
        id
        firstName
        lastName
        description
        image @include(if: $withTravelGuidesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      teams @include(if: $withTeams) {
        id
        name
        members @include(if: $withTeamsMembers) {
          id
          firstName
          lastName
          description
          image @include(if: $withTeamsMembersImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
      }
      accommodationAssignments @include(if: $withAccommodationAssignments) {
        id
        accommodation @include(if: $withAccommodationAssignmentsAccommodation) {
          id
          label
          name
          stars
          description
          roomTypes @include(if: $withAccommodationAssignmentsAccommodationRoomTypes) {
            id
            name
            description
          }
          availableAddons @include(if: $withAccommodationAssignmentsAccommodationAvailableAddons) {
            id
            name
            description
          }
          gallery @include(if: $withAccommodationAssignmentsAccommodationGallery) {
            id
          }
        }
        roomTypes @include(if: $withAccommodationAssignmentsRoomTypes) {
          id
          name
          description
          gallery @include(if: $withAccommodationAssignmentsRoomTypesGallery) {
            id
          }
        }
        useCustomRoomTypeSelection
        displayDetails
      }
      accommodations @include(if: $withAccommodations) {
        id
        label
        name
        stars
        description
        roomTypes @include(if: $withAccommodationsRoomTypes) {
          id
          name
          description
          gallery @include(if: $withAccommodationsRoomTypesGallery) {
            id
          }
        }
        availableAddons @include(if: $withAccommodationsAvailableAddons) {
          id
          name
          description
          icon @include(if: $withAccommodationsAvailableAddonsIcon) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        gallery @include(if: $withAccommodationsGallery) {
          id
          images @include(if: $withAccommodationsGalleryImages) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
      }
      destinations @include(if: $withDestinations) {
        id
        name
        entryRequirements
        medicalInformation
        language
        timeShift
        climate
        currency
      }
      testimonials @include(if: $withTestimonials) {
        id
        contentBlock @include(if: $withTestimonialsContentBlock) {
          id
          title
          text
          image @include(if: $withTestimonialsContentBlockImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          imagePosition
        }
      }
      mainImage @include(if: $withMainImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      mainVideo @include(if: $withMainVideo) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      gallery @include(if: $withGallery) {
        id
        images @include(if: $withGalleryImages) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      travelPdf @include(if: $withTravelPdf) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      travelExtensions @include(if: $withTravelExtensions) {
        id
        duration
        name
        description
        highlights @include(if: $withTravelExtensionsHighlights) {
          id
          text
        }
        image @include(if: $withTravelExtensionsImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      programType
      itinerary @include(if: $withItinerary) {
        id
        items @include(if: $withItineraryItems) {
          id
          duration
          title
          text
          image @include(if: $withItineraryItemsImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          mapMarkers @include(if: $withItineraryItemsMapMarkers) {
            id
            lat
            lng
          }
        }
      }
      programText
      pricing @include(if: $withPricing) {
        id
        ageGroupSettings @include(if: $withPricingAgeGroupSettings) {
          id
          freeUntilAge
          ageGroups @include(if: $withPricingAgeGroupSettingsAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
        }
        isTravelDocumentationAvailable
        customDataConfig @include(if: $withPricingCustomDataConfig) {
          id
          useTravellerForm
          travellerForm @include(if: $withPricingCustomDataConfigTravellerForm) {
            id
          }
          useBookingForm
          bookingForm @include(if: $withPricingCustomDataConfigBookingForm) {
            id
          }
        }
        travels @include(if: $withPricingTravels) {
          id
          ratioCatalogBundle @include(if: $withPricingTravelsRatioCatalogBundle) {
            id
            catalogCode
            travelCode
            json
          }
          catalogCode
          travelCode
          destination
          name
          transportType
          transportTypeLabel
          dates @include(if: $withPricingTravelsDates) {
            id
            dateNo
            startDate
            endDate
            isHidden
            includesExtension
            json
          }
          accommodations @include(if: $withPricingTravelsAccommodations) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          extensionAccommodations @include(if: $withPricingTravelsExtensionAccommodations) {
            id
            ratioPackageNo
            name
            label
            info
            extensionAccommodationServiceNo
          }
          familyPackages @include(if: $withPricingTravelsFamilyPackages) {
            id
            ratioServiceNo
            name
            label
            info
          }
          personalAddons @include(if: $withPricingTravelsPersonalAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
          accommodationAddons @include(if: $withPricingTravelsAccommodationAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
          bookingAddons @include(if: $withPricingTravelsBookingAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
          collectiveAddons @include(if: $withPricingTravelsCollectiveAddons) {
            id
            label
            info
          }
          extensions @include(if: $withPricingTravelsExtensions) {
            id
            label
            info
          }
          personalDiscounts @include(if: $withPricingTravelsPersonalDiscounts) {
            id
            ratioServiceNo
            name
            label
            info
          }
          bookingDiscounts @include(if: $withPricingTravelsBookingDiscounts) {
            id
            ratioServiceNo
            name
            label
            info
          }
          collectiveDiscounts @include(if: $withPricingTravelsCollectiveDiscounts) {
            id
            label
            info
          }
          importDateTime
          importStatus
          suppressBusBoardingSelection
        }
        webhookConfig @include(if: $withPricingWebhookConfig) {
          id
          enabled
          url
        }
        branding @include(if: $withPricingBranding) {
          id
          logo @include(if: $withPricingBrandingLogo) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          logoWidth
        }
        bargainSettings @include(if: $withPricingBargainSettings) {
          id
          active
          untilDaysBeforeStart
          bargainTier @include(if: $withPricingBargainSettingsBargainTier) {
            id
            fromPrice
            discount
          }
        }
        esimSettings @include(if: $withPricingEsimSettings) {
          id
          enabled
          regions @include(if: $withPricingEsimSettingsRegions) {
            id
            name
            serviceCodePrefix
          }
        }
        passportConfig @include(if: $withPricingPassportConfig) {
          id
          passportOnly
        }
        tourOperator @include(if: $withPricingTourOperator) {
          id
          name
          url
          logo @include(if: $withPricingTourOperatorLogo) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          logoWidth
          gtcPdf @include(if: $withPricingTourOperatorGtcPdf) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        currencyOverride @include(if: $withPricingCurrencyOverride) {
          id
          enabled
          currency @include(if: $withPricingCurrencyOverrideCurrency) {
            id
            name
            symbol
            code
            isDefault
            exchangeRate
            defaultCountries
          }
          exchangeRate
        }
      }
      minPrice
      minPriceManualOverride
      currency
      faqs @include(if: $withFaqs) {
        id
        question
        answer
      }
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_MUTATION = `
  mutation Mutation($input: UpdateTravelInput, $withAvailabilityStatus: Boolean = false, $withAvailabilityStatusTenantSettings: Boolean = false, $withAvailabilityStatusTenantSettingsTenant: Boolean = false, $withTravelConsultant: Boolean = false, $withTravelConsultantImage: Boolean = false, $withLabel: Boolean = false, $withSeoSettings: Boolean = false, $withSeoSettingsOgImage: Boolean = false, $withTenantSettings: Boolean = false, $withTenantSettingsTenant: Boolean = false, $withTenantSettingsTenantCms: Boolean = false, $withTenantSettingsTenantTravelTypes: Boolean = false, $withTenantSettingsTenantEmployees: Boolean = false, $withTenantSettingsTenantEmailConfig: Boolean = false, $withTenantSettingsTenantNewsletterProvider: Boolean = false, $withTenantSettingsTenantRedirects: Boolean = false, $withTenantSettingsTenantOnlinePaymentConfig: Boolean = false, $withTenantSettingsTenantRatioConfig: Boolean = false, $withTenantSettingsTenantContent: Boolean = false, $withTenantSettingsTenantPartnerTenants: Boolean = false, $withTenantSettingsTravelTypes: Boolean = false, $withTenantSettingsTravelTypesImage: Boolean = false, $withHighlights: Boolean = false, $withPartners: Boolean = false, $withPartnersLogo: Boolean = false, $withPartnersGtcPdf: Boolean = false, $withTravelGuides: Boolean = false, $withTravelGuidesImage: Boolean = false, $withTeams: Boolean = false, $withTeamsMembers: Boolean = false, $withTeamsMembersImage: Boolean = false, $withAccommodationAssignments: Boolean = false, $withAccommodationAssignmentsAccommodation: Boolean = false, $withAccommodationAssignmentsAccommodationRoomTypes: Boolean = false, $withAccommodationAssignmentsAccommodationAvailableAddons: Boolean = false, $withAccommodationAssignmentsAccommodationGallery: Boolean = false, $withAccommodationAssignmentsRoomTypes: Boolean = false, $withAccommodationAssignmentsRoomTypesGallery: Boolean = false, $withAccommodations: Boolean = false, $withAccommodationsRoomTypes: Boolean = false, $withAccommodationsRoomTypesGallery: Boolean = false, $withAccommodationsAvailableAddons: Boolean = false, $withAccommodationsAvailableAddonsIcon: Boolean = false, $withAccommodationsGallery: Boolean = false, $withAccommodationsGalleryImages: Boolean = false, $withDestinations: Boolean = false, $withTestimonials: Boolean = false, $withTestimonialsContentBlock: Boolean = false, $withTestimonialsContentBlockImage: Boolean = false, $withMainImage: Boolean = false, $withMainVideo: Boolean = false, $withGallery: Boolean = false, $withGalleryImages: Boolean = false, $withTravelPdf: Boolean = false, $withTravelExtensions: Boolean = false, $withTravelExtensionsHighlights: Boolean = false, $withTravelExtensionsImage: Boolean = false, $withItinerary: Boolean = false, $withItineraryItems: Boolean = false, $withItineraryItemsImage: Boolean = false, $withItineraryItemsMapMarkers: Boolean = false, $withPricing: Boolean = false, $withPricingAgeGroupSettings: Boolean = false, $withPricingAgeGroupSettingsAgeGroups: Boolean = false, $withPricingCustomDataConfig: Boolean = false, $withPricingCustomDataConfigTravellerForm: Boolean = false, $withPricingCustomDataConfigBookingForm: Boolean = false, $withPricingTravels: Boolean = false, $withPricingTravelsRatioCatalogBundle: Boolean = false, $withPricingTravelsDates: Boolean = false, $withPricingTravelsAccommodations: Boolean = false, $withPricingTravelsExtensionAccommodations: Boolean = false, $withPricingTravelsFamilyPackages: Boolean = false, $withPricingTravelsPersonalAddons: Boolean = false, $withPricingTravelsAccommodationAddons: Boolean = false, $withPricingTravelsBookingAddons: Boolean = false, $withPricingTravelsCollectiveAddons: Boolean = false, $withPricingTravelsExtensions: Boolean = false, $withPricingTravelsPersonalDiscounts: Boolean = false, $withPricingTravelsBookingDiscounts: Boolean = false, $withPricingTravelsCollectiveDiscounts: Boolean = false, $withPricingWebhookConfig: Boolean = false, $withPricingBranding: Boolean = false, $withPricingBrandingLogo: Boolean = false, $withPricingBargainSettings: Boolean = false, $withPricingBargainSettingsBargainTier: Boolean = false, $withPricingEsimSettings: Boolean = false, $withPricingEsimSettingsRegions: Boolean = false, $withPricingPassportConfig: Boolean = false, $withPricingTourOperator: Boolean = false, $withPricingTourOperatorLogo: Boolean = false, $withPricingTourOperatorGtcPdf: Boolean = false, $withPricingCurrencyOverride: Boolean = false, $withPricingCurrencyOverrideCurrency: Boolean = false, $withFaqs: Boolean = false) {
    travel: updateTravel(input: $input) {
      id
      name
      isBestseller
      startDate
      endDate
      availabilityStatus @include(if: $withAvailabilityStatus) {
        id
        label
        status
        isDefaultStatus
        isDefaultWaitlistFallback
        tenantSettings @include(if: $withAvailabilityStatusTenantSettings) {
          id
          tenant @include(if: $withAvailabilityStatusTenantSettingsTenant) {
            id
            name
            slug
            domain
            externalReference
          }
          label
          info
          switchToStatusInfo
          submitButtonLabel
        }
      }
      executionStatus
      travelConsultant @include(if: $withTravelConsultant) {
        id
        firstName
        lastName
        jobTitle
        description
        email
        image @include(if: $withTravelConsultantImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        phone
      }
      label @include(if: $withLabel) {
        id
        label
      }
      title
      description
      introVideoUrl
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      seoSettings @include(if: $withSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      tenantSettings @include(if: $withTenantSettings) {
        id
        tenant @include(if: $withTenantSettingsTenant) {
          id
          name
          slug
          domain
          externalReference
          cms @include(if: $withTenantSettingsTenantCms) {
            id
          }
          travelTypes @include(if: $withTenantSettingsTenantTravelTypes) {
            id
            name
            description
          }
          employees @include(if: $withTenantSettingsTenantEmployees) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }
          emailConfig @include(if: $withTenantSettingsTenantEmailConfig) {
            id
            defaultInternalRecipientEmail
            internalBookingRecipientEmails
            bookingConfirmationTemplateId
            bookingConfirmationInternalTemplateId
            bookingRequestConfirmationTemplateId
            bookingWaitlistConfirmationTemplateId
            bookingWaitlistContingentCheckConfirmationTemplateId
            bookingCustomRequestTemplateId
            bookingPassportDataReminderTemplateId
            previewTravelInterestTemplateId
            contactFormTemplateId
            esimInstallationInfoTemplateId
          }
          newsletterProvider @include(if: $withTenantSettingsTenantNewsletterProvider) {
            id
            provider
          }
          redirects @include(if: $withTenantSettingsTenantRedirects) {
            id
            fromType
            fromUrl
            toType
            toUrl
          }
          onlinePaymentConfig @include(if: $withTenantSettingsTenantOnlinePaymentConfig) {
            id
            enabled
            datatransMerchantId
            datatransMerchantPw
            ratioFibuAccountNo
            infoText
            datatransThemeConfig
          }
          ratioConfig @include(if: $withTenantSettingsTenantRatioConfig) {
            id
            adressgruppe
          }
          content @include(if: $withTenantSettingsTenantContent) {
            id
            bookingInsuranceInfo
            co2CompensationInfo
          }
          partnerTenants @include(if: $withTenantSettingsTenantPartnerTenants) {
            id
            filterCrossLinking
          }
        }
        onlineStatus
        redirectToBooking
        useTiming
        startDate
        endDate
        travelTypes @include(if: $withTenantSettingsTravelTypes) {
          id
          name
          description
          image @include(if: $withTenantSettingsTravelTypesImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
      }
      highlights @include(if: $withHighlights) {
        id
        text
      }
      partners @include(if: $withPartners) {
        id
        name
        url
        logo @include(if: $withPartnersLogo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        logoWidth
        gtcPdf @include(if: $withPartnersGtcPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      travelGuides @include(if: $withTravelGuides) {
        id
        firstName
        lastName
        description
        image @include(if: $withTravelGuidesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      teams @include(if: $withTeams) {
        id
        name
        members @include(if: $withTeamsMembers) {
          id
          firstName
          lastName
          description
          image @include(if: $withTeamsMembersImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
      }
      accommodationAssignments @include(if: $withAccommodationAssignments) {
        id
        accommodation @include(if: $withAccommodationAssignmentsAccommodation) {
          id
          label
          name
          stars
          description
          roomTypes @include(if: $withAccommodationAssignmentsAccommodationRoomTypes) {
            id
            name
            description
          }
          availableAddons @include(if: $withAccommodationAssignmentsAccommodationAvailableAddons) {
            id
            name
            description
          }
          gallery @include(if: $withAccommodationAssignmentsAccommodationGallery) {
            id
          }
        }
        roomTypes @include(if: $withAccommodationAssignmentsRoomTypes) {
          id
          name
          description
          gallery @include(if: $withAccommodationAssignmentsRoomTypesGallery) {
            id
          }
        }
        useCustomRoomTypeSelection
        displayDetails
      }
      accommodations @include(if: $withAccommodations) {
        id
        label
        name
        stars
        description
        roomTypes @include(if: $withAccommodationsRoomTypes) {
          id
          name
          description
          gallery @include(if: $withAccommodationsRoomTypesGallery) {
            id
          }
        }
        availableAddons @include(if: $withAccommodationsAvailableAddons) {
          id
          name
          description
          icon @include(if: $withAccommodationsAvailableAddonsIcon) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        gallery @include(if: $withAccommodationsGallery) {
          id
          images @include(if: $withAccommodationsGalleryImages) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
      }
      destinations @include(if: $withDestinations) {
        id
        name
        entryRequirements
        medicalInformation
        language
        timeShift
        climate
        currency
      }
      testimonials @include(if: $withTestimonials) {
        id
        contentBlock @include(if: $withTestimonialsContentBlock) {
          id
          title
          text
          image @include(if: $withTestimonialsContentBlockImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          imagePosition
        }
      }
      mainImage @include(if: $withMainImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      mainVideo @include(if: $withMainVideo) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      gallery @include(if: $withGallery) {
        id
        images @include(if: $withGalleryImages) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      travelPdf @include(if: $withTravelPdf) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      travelExtensions @include(if: $withTravelExtensions) {
        id
        duration
        name
        description
        highlights @include(if: $withTravelExtensionsHighlights) {
          id
          text
        }
        image @include(if: $withTravelExtensionsImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      programType
      itinerary @include(if: $withItinerary) {
        id
        items @include(if: $withItineraryItems) {
          id
          duration
          title
          text
          image @include(if: $withItineraryItemsImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          mapMarkers @include(if: $withItineraryItemsMapMarkers) {
            id
            lat
            lng
          }
        }
      }
      programText
      pricing @include(if: $withPricing) {
        id
        ageGroupSettings @include(if: $withPricingAgeGroupSettings) {
          id
          freeUntilAge
          ageGroups @include(if: $withPricingAgeGroupSettingsAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
        }
        isTravelDocumentationAvailable
        customDataConfig @include(if: $withPricingCustomDataConfig) {
          id
          useTravellerForm
          travellerForm @include(if: $withPricingCustomDataConfigTravellerForm) {
            id
          }
          useBookingForm
          bookingForm @include(if: $withPricingCustomDataConfigBookingForm) {
            id
          }
        }
        travels @include(if: $withPricingTravels) {
          id
          ratioCatalogBundle @include(if: $withPricingTravelsRatioCatalogBundle) {
            id
            catalogCode
            travelCode
            json
          }
          catalogCode
          travelCode
          destination
          name
          transportType
          transportTypeLabel
          dates @include(if: $withPricingTravelsDates) {
            id
            dateNo
            startDate
            endDate
            isHidden
            includesExtension
            json
          }
          accommodations @include(if: $withPricingTravelsAccommodations) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          extensionAccommodations @include(if: $withPricingTravelsExtensionAccommodations) {
            id
            ratioPackageNo
            name
            label
            info
            extensionAccommodationServiceNo
          }
          familyPackages @include(if: $withPricingTravelsFamilyPackages) {
            id
            ratioServiceNo
            name
            label
            info
          }
          personalAddons @include(if: $withPricingTravelsPersonalAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
          accommodationAddons @include(if: $withPricingTravelsAccommodationAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
          bookingAddons @include(if: $withPricingTravelsBookingAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
          collectiveAddons @include(if: $withPricingTravelsCollectiveAddons) {
            id
            label
            info
          }
          extensions @include(if: $withPricingTravelsExtensions) {
            id
            label
            info
          }
          personalDiscounts @include(if: $withPricingTravelsPersonalDiscounts) {
            id
            ratioServiceNo
            name
            label
            info
          }
          bookingDiscounts @include(if: $withPricingTravelsBookingDiscounts) {
            id
            ratioServiceNo
            name
            label
            info
          }
          collectiveDiscounts @include(if: $withPricingTravelsCollectiveDiscounts) {
            id
            label
            info
          }
          importDateTime
          importStatus
          suppressBusBoardingSelection
        }
        webhookConfig @include(if: $withPricingWebhookConfig) {
          id
          enabled
          url
        }
        branding @include(if: $withPricingBranding) {
          id
          logo @include(if: $withPricingBrandingLogo) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          logoWidth
        }
        bargainSettings @include(if: $withPricingBargainSettings) {
          id
          active
          untilDaysBeforeStart
          bargainTier @include(if: $withPricingBargainSettingsBargainTier) {
            id
            fromPrice
            discount
          }
        }
        esimSettings @include(if: $withPricingEsimSettings) {
          id
          enabled
          regions @include(if: $withPricingEsimSettingsRegions) {
            id
            name
            serviceCodePrefix
          }
        }
        passportConfig @include(if: $withPricingPassportConfig) {
          id
          passportOnly
        }
        tourOperator @include(if: $withPricingTourOperator) {
          id
          name
          url
          logo @include(if: $withPricingTourOperatorLogo) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          logoWidth
          gtcPdf @include(if: $withPricingTourOperatorGtcPdf) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        currencyOverride @include(if: $withPricingCurrencyOverride) {
          id
          enabled
          currency @include(if: $withPricingCurrencyOverrideCurrency) {
            id
            name
            symbol
            code
            isDefault
            exchangeRate
            defaultCountries
          }
          exchangeRate
        }
      }
      minPrice
      minPriceManualOverride
      currency
      faqs @include(if: $withFaqs) {
        id
        question
        answer
      }
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_MUTATION = `
  mutation Mutation($input: DeleteTravelInput) {
    deleteTravel(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_TRAVEL_MUTATION = `
  mutation Mutation($input: DeleteTravelInput) {
    forceDeleteTravel(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_TRAVEL_TENANT_SETTINGS_MUTATION = `
  mutation Mutation($input: addTravelTenantSettingsInput) {
    addTravelTenantSettings(input: $input) {
      id
      tenantSettingsIds
    }
  }`

// language=GraphQL
export const REMOVE_TRAVEL_TENANT_SETTINGS_MUTATION = `
  mutation Mutation($input: removeTravelTenantSettingsInput) {
    removeTravelTenantSettings(input: $input) {
      id
      tenantSettingsIds
    }
  }`

// language=GraphQL
export const CREATE_TRAVEL_TENANT_SETTINGS_MUTATION = `
  mutation Mutation($input: createTravelTenantSettingsInput) {
    createTravelTenantSettings(input: $input) {
      id
      tenantSettingsIds
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_TENANT_SETTINGS_MUTATION = `
  mutation Mutation($input: deleteTravelTenantSettingsInput) {
    deleteTravelTenantSettings(input: $input) {
      id
      tenantSettingsIds
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_TENANT_SETTINGS_ORDER_MUTATION = `
  mutation Mutation($input: updateTravelTenantSettingsOrderInput) {
    updateTravelTenantSettingsOrder(input: $input) {
      id
      tenantSettingsIds
    }
  }`

// language=GraphQL
export const ADD_TRAVEL_HIGHLIGHTS_MUTATION = `
  mutation Mutation($input: addTravelHighlightsInput) {
    addTravelHighlights(input: $input) {
      id
      highlightIds
    }
  }`

// language=GraphQL
export const REMOVE_TRAVEL_HIGHLIGHTS_MUTATION = `
  mutation Mutation($input: removeTravelHighlightsInput) {
    removeTravelHighlights(input: $input) {
      id
      highlightIds
    }
  }`

// language=GraphQL
export const CREATE_TRAVEL_HIGHLIGHTS_MUTATION = `
  mutation Mutation($input: createTravelHighlightsInput) {
    createTravelHighlights(input: $input) {
      id
      highlightIds
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_HIGHLIGHTS_MUTATION = `
  mutation Mutation($input: deleteTravelHighlightsInput) {
    deleteTravelHighlights(input: $input) {
      id
      highlightIds
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_HIGHLIGHTS_ORDER_MUTATION = `
  mutation Mutation($input: updateTravelHighlightsOrderInput) {
    updateTravelHighlightsOrder(input: $input) {
      id
      highlightIds
    }
  }`

// language=GraphQL
export const ADD_TRAVEL_PARTNERS_MUTATION = `
  mutation Mutation($input: addTravelPartnersInput) {
    addTravelPartners(input: $input) {
      id
      partnerIds
    }
  }`

// language=GraphQL
export const REMOVE_TRAVEL_PARTNERS_MUTATION = `
  mutation Mutation($input: removeTravelPartnersInput) {
    removeTravelPartners(input: $input) {
      id
      partnerIds
    }
  }`

// language=GraphQL
export const CREATE_TRAVEL_PARTNERS_MUTATION = `
  mutation Mutation($input: createTravelPartnersInput) {
    createTravelPartners(input: $input) {
      id
      partnerIds
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_PARTNERS_MUTATION = `
  mutation Mutation($input: deleteTravelPartnersInput) {
    deleteTravelPartners(input: $input) {
      id
      partnerIds
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_PARTNERS_ORDER_MUTATION = `
  mutation Mutation($input: updateTravelPartnersOrderInput) {
    updateTravelPartnersOrder(input: $input) {
      id
      partnerIds
    }
  }`

// language=GraphQL
export const ADD_TRAVEL_TRAVEL_GUIDES_MUTATION = `
  mutation Mutation($input: addTravelTravelGuidesInput) {
    addTravelTravelGuides(input: $input) {
      id
      travelGuideIds
    }
  }`

// language=GraphQL
export const REMOVE_TRAVEL_TRAVEL_GUIDES_MUTATION = `
  mutation Mutation($input: removeTravelTravelGuidesInput) {
    removeTravelTravelGuides(input: $input) {
      id
      travelGuideIds
    }
  }`

// language=GraphQL
export const CREATE_TRAVEL_TRAVEL_GUIDES_MUTATION = `
  mutation Mutation($input: createTravelTravelGuidesInput) {
    createTravelTravelGuides(input: $input) {
      id
      travelGuideIds
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_TRAVEL_GUIDES_MUTATION = `
  mutation Mutation($input: deleteTravelTravelGuidesInput) {
    deleteTravelTravelGuides(input: $input) {
      id
      travelGuideIds
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_TRAVEL_GUIDES_ORDER_MUTATION = `
  mutation Mutation($input: updateTravelTravelGuidesOrderInput) {
    updateTravelTravelGuidesOrder(input: $input) {
      id
      travelGuideIds
    }
  }`

// language=GraphQL
export const ADD_TRAVEL_TEAMS_MUTATION = `
  mutation Mutation($input: addTravelTeamsInput) {
    addTravelTeams(input: $input) {
      id
      teamIds
    }
  }`

// language=GraphQL
export const REMOVE_TRAVEL_TEAMS_MUTATION = `
  mutation Mutation($input: removeTravelTeamsInput) {
    removeTravelTeams(input: $input) {
      id
      teamIds
    }
  }`

// language=GraphQL
export const CREATE_TRAVEL_TEAMS_MUTATION = `
  mutation Mutation($input: createTravelTeamsInput) {
    createTravelTeams(input: $input) {
      id
      teamIds
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_TEAMS_MUTATION = `
  mutation Mutation($input: deleteTravelTeamsInput) {
    deleteTravelTeams(input: $input) {
      id
      teamIds
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_TEAMS_ORDER_MUTATION = `
  mutation Mutation($input: updateTravelTeamsOrderInput) {
    updateTravelTeamsOrder(input: $input) {
      id
      teamIds
    }
  }`

// language=GraphQL
export const ADD_TRAVEL_ACCOMMODATION_ASSIGNMENTS_MUTATION = `
  mutation Mutation($input: addTravelAccommodationAssignmentsInput) {
    addTravelAccommodationAssignments(input: $input) {
      id
      accommodationAssignmentIds
    }
  }`

// language=GraphQL
export const REMOVE_TRAVEL_ACCOMMODATION_ASSIGNMENTS_MUTATION = `
  mutation Mutation($input: removeTravelAccommodationAssignmentsInput) {
    removeTravelAccommodationAssignments(input: $input) {
      id
      accommodationAssignmentIds
    }
  }`

// language=GraphQL
export const CREATE_TRAVEL_ACCOMMODATION_ASSIGNMENTS_MUTATION = `
  mutation Mutation($input: createTravelAccommodationAssignmentsInput) {
    createTravelAccommodationAssignments(input: $input) {
      id
      accommodationAssignmentIds
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_ACCOMMODATION_ASSIGNMENTS_MUTATION = `
  mutation Mutation($input: deleteTravelAccommodationAssignmentsInput) {
    deleteTravelAccommodationAssignments(input: $input) {
      id
      accommodationAssignmentIds
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_ACCOMMODATION_ASSIGNMENTS_ORDER_MUTATION = `
  mutation Mutation($input: updateTravelAccommodationAssignmentsOrderInput) {
    updateTravelAccommodationAssignmentsOrder(input: $input) {
      id
      accommodationAssignmentIds
    }
  }`

// language=GraphQL
export const ADD_TRAVEL_ACCOMMODATIONS_MUTATION = `
  mutation Mutation($input: addTravelAccommodationsInput) {
    addTravelAccommodations(input: $input) {
      id
      accommodationIds
    }
  }`

// language=GraphQL
export const REMOVE_TRAVEL_ACCOMMODATIONS_MUTATION = `
  mutation Mutation($input: removeTravelAccommodationsInput) {
    removeTravelAccommodations(input: $input) {
      id
      accommodationIds
    }
  }`

// language=GraphQL
export const CREATE_TRAVEL_ACCOMMODATIONS_MUTATION = `
  mutation Mutation($input: createTravelAccommodationsInput) {
    createTravelAccommodations(input: $input) {
      id
      accommodationIds
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_ACCOMMODATIONS_MUTATION = `
  mutation Mutation($input: deleteTravelAccommodationsInput) {
    deleteTravelAccommodations(input: $input) {
      id
      accommodationIds
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_ACCOMMODATIONS_ORDER_MUTATION = `
  mutation Mutation($input: updateTravelAccommodationsOrderInput) {
    updateTravelAccommodationsOrder(input: $input) {
      id
      accommodationIds
    }
  }`

// language=GraphQL
export const ADD_TRAVEL_DESTINATIONS_MUTATION = `
  mutation Mutation($input: addTravelDestinationsInput) {
    addTravelDestinations(input: $input) {
      id
      destinationIds
    }
  }`

// language=GraphQL
export const REMOVE_TRAVEL_DESTINATIONS_MUTATION = `
  mutation Mutation($input: removeTravelDestinationsInput) {
    removeTravelDestinations(input: $input) {
      id
      destinationIds
    }
  }`

// language=GraphQL
export const CREATE_TRAVEL_DESTINATIONS_MUTATION = `
  mutation Mutation($input: createTravelDestinationsInput) {
    createTravelDestinations(input: $input) {
      id
      destinationIds
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_DESTINATIONS_MUTATION = `
  mutation Mutation($input: deleteTravelDestinationsInput) {
    deleteTravelDestinations(input: $input) {
      id
      destinationIds
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_DESTINATIONS_ORDER_MUTATION = `
  mutation Mutation($input: updateTravelDestinationsOrderInput) {
    updateTravelDestinationsOrder(input: $input) {
      id
      destinationIds
    }
  }`

// language=GraphQL
export const ADD_TRAVEL_TESTIMONIALS_MUTATION = `
  mutation Mutation($input: addTravelTestimonialsInput) {
    addTravelTestimonials(input: $input) {
      id
      testimonialIds
    }
  }`

// language=GraphQL
export const REMOVE_TRAVEL_TESTIMONIALS_MUTATION = `
  mutation Mutation($input: removeTravelTestimonialsInput) {
    removeTravelTestimonials(input: $input) {
      id
      testimonialIds
    }
  }`

// language=GraphQL
export const CREATE_TRAVEL_TESTIMONIALS_MUTATION = `
  mutation Mutation($input: createTravelTestimonialsInput) {
    createTravelTestimonials(input: $input) {
      id
      testimonialIds
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_TESTIMONIALS_MUTATION = `
  mutation Mutation($input: deleteTravelTestimonialsInput) {
    deleteTravelTestimonials(input: $input) {
      id
      testimonialIds
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_TESTIMONIALS_ORDER_MUTATION = `
  mutation Mutation($input: updateTravelTestimonialsOrderInput) {
    updateTravelTestimonialsOrder(input: $input) {
      id
      testimonialIds
    }
  }`

// language=GraphQL
export const ADD_TRAVEL_TRAVEL_EXTENSIONS_MUTATION = `
  mutation Mutation($input: addTravelTravelExtensionsInput) {
    addTravelTravelExtensions(input: $input) {
      id
      travelExtensionIds
    }
  }`

// language=GraphQL
export const REMOVE_TRAVEL_TRAVEL_EXTENSIONS_MUTATION = `
  mutation Mutation($input: removeTravelTravelExtensionsInput) {
    removeTravelTravelExtensions(input: $input) {
      id
      travelExtensionIds
    }
  }`

// language=GraphQL
export const CREATE_TRAVEL_TRAVEL_EXTENSIONS_MUTATION = `
  mutation Mutation($input: createTravelTravelExtensionsInput) {
    createTravelTravelExtensions(input: $input) {
      id
      travelExtensionIds
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_TRAVEL_EXTENSIONS_MUTATION = `
  mutation Mutation($input: deleteTravelTravelExtensionsInput) {
    deleteTravelTravelExtensions(input: $input) {
      id
      travelExtensionIds
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_TRAVEL_EXTENSIONS_ORDER_MUTATION = `
  mutation Mutation($input: updateTravelTravelExtensionsOrderInput) {
    updateTravelTravelExtensionsOrder(input: $input) {
      id
      travelExtensionIds
    }
  }`

// language=GraphQL
export const ADD_TRAVEL_FAQS_MUTATION = `
  mutation Mutation($input: addTravelFaqsInput) {
    addTravelFaqs(input: $input) {
      id
      faqIds
    }
  }`

// language=GraphQL
export const REMOVE_TRAVEL_FAQS_MUTATION = `
  mutation Mutation($input: removeTravelFaqsInput) {
    removeTravelFaqs(input: $input) {
      id
      faqIds
    }
  }`

// language=GraphQL
export const CREATE_TRAVEL_FAQS_MUTATION = `
  mutation Mutation($input: createTravelFaqsInput) {
    createTravelFaqs(input: $input) {
      id
      faqIds
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_FAQS_MUTATION = `
  mutation Mutation($input: deleteTravelFaqsInput) {
    deleteTravelFaqs(input: $input) {
      id
      faqIds
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_FAQS_ORDER_MUTATION = `
  mutation Mutation($input: updateTravelFaqsOrderInput) {
    updateTravelFaqsOrder(input: $input) {
      id
      faqIds
    }
  }`

// language=GraphQL
export const TRAVELS_DEPENDENTS_QUERY = `query Query($id: ID!, $withBookings: Boolean = false, $withRedirects: Boolean = false, $withLinks: Boolean = false, $withCmsHeaderSliderBlocks: Boolean = false, $withCmsTravelSelectionBlocks: Boolean = false) {
  groupedDependents: travelDependents(id: $id) {
    bookings @include(if: $withBookings) {
      id
      referenceNo
      travellerRemarks
      travellerDataCorrectnessConfirmation
      localState
      backofficePayload
      backofficeResponse
      transmissionStatus
      webhookStatus
      webhookResponse
      webhookDuration
      confirmationEmailSent
      isPassportDataRequired
      passportDataReminderEmailSent
      passportDataReceived
      newsletterRegistrationSubmittedAt    }
    redirects @include(if: $withRedirects) {
      id
      fromType
      fromUrl
      toType
      toUrl
    }
    links @include(if: $withLinks) {
      id
      label
      targetBlank
      type
      url
    }
    cmsHeaderSliderBlocks @include(if: $withCmsHeaderSliderBlocks) {
      id
    }
    cmsTravelSelectionBlocks @include(if: $withCmsTravelSelectionBlocks) {
      id
    }
  }
}`
